<template>
    <v-row dense>
        <v-col cols="12" md="12">
            <v-card variant="outlined">
                <v-card-text>
                    <v-row no-gutters>
                        <v-spacer />
                        <v-switch
                            v-model="discountForEdit.active"
                            hide-details
                            :label="discountForEdit.active ? $t('active') : $t('inactive')"
                        />
                    </v-row>
                    <!-- ZSH: discount type radio group is hidden per client request, default value still applies -->
                    <v-radio-group
                        v-model="discountForEdit.type"
                        inline
                        hide-details
                        class="pb-4"
                        style="display: none"
                    >
                        <v-radio
                            v-for="discountType in discountTypeItems"
                            :key="discountType.value"
                            :value="discountType.value"
                            :label="discountType.title"
                        />
                    </v-radio-group>
                    <v-row no-gutters>
                        <v-col cols="12" md="4">
                            <TextFieldLocale
                                v-model="discountForEdit.name[selectedLocale]"
                                :label="`${$t('name')}*`"
                                :rules="[requiredRule('name')]"
                                :active-lang-code="selectedLocale"
                                hide-details="auto"
                                data-cy="discount-name"
                            />
                        </v-col>
                    </v-row>
                    <slot />
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
    import TextFieldLocale from '~/components/TextFieldLocale.vue'

    const props = defineProps<{
        selectedLocale: string
        discountTypeItems: {[key: string]: string}[]
    }>()

    const discountForEdit = defineModel<any>()
</script>
